export class ICompanyTable{
    id: number = 0;
    name: string = "";
    laboralSector: number = 0;
    nit: number = 0;
    verificationDigit: number = 0;
    fullNit?: string = "";
    state: string = "";
    city: number = 0;
}